import TargetDefinition from './TargetDefinition.vue'

export { default as createModule } from './store'
export default TargetDefinition



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/targetDefinition/index.js